import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from '../CTAButton';
const notThis = ['Another textbook', 'Another online course', 'Another collection of clinical guidelines'];
export function Different() {
  return <Section tone="white" data-id="element-101" data-mp="2zskstkvso38">
      <SectionTitle eyebrow="The difference" data-id="element-102" data-mp="2zis2y8gc2tu">
        What Makes This Different?
      </SectionTitle>

      <ul className="mt-6 space-y-2.5" data-id="element-103" data-mp="gq4aymxwocrq">
        {notThis.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-navy/[0.04] px-4 py-3 text-[14.5px] font-medium text-navy/60" data-id="element-104" data-mp="cqvlhu9wf11z">
            <XIcon className="h-4 w-4 shrink-0 text-red-500" data-id="element-105" data-mp="lr1sqyf074sp" />
            <span className="line-through decoration-navy/25" data-id="element-106" data-mp="lrl8q9l3fj43">{item}</span>
          </li>)}
      </ul>

      <div className="mt-6 rounded-3xl border-2 border-gold/50 bg-gold/[0.07] p-6" data-id="element-107" data-mp="2sjcdvuif7wnm">
        <p className="flex items-start gap-3 font-display text-lg font-bold leading-snug text-navy sm:text-2xl" data-id="element-108" data-mp="2njzqn8nn0nki">
          <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-gold-dark" data-id="element-109" data-mp="3d12pew64ods8" />
          It is a complete clinical decision system designed to help you
          confidently manage menopause patients from the initial assessment
          through long-term follow-up.
        </p>
        <div className="mt-5 border-t border-gold/30 pt-5 text-[15px] leading-relaxed text-navy/75" data-id="element-110" data-mp="3qw50rytquvcf">
          <p data-id="element-111" data-mp="3vt56u9qlfy3j">Every recommendation follows the latest evidence.</p>
          <p className="mt-2" data-id="element-112" data-mp="4mkl95jb5idw">
            Every algorithm answers the question:{' '}
            <strong className="text-navy" data-id="element-113" data-mp="9mq888emugpn">"What should I do next?"</strong>
          </p>
        </div>
      </div>

      <CTAButton className="mt-8" variant="navy" label="Give me the complete decision system" subline="6 volumes + 5 bonuses • $27 today" data-id="element-114" data-mp="dobp04uaff54" />
    </Section>;
}